import { createHelpers } from 'vuex-map-fields';

const { getFieldContratadas, updateFieldContratadas } = createHelpers({
  getterType: 'getFieldContratadas',
  mutationType: 'updateFieldContratadas',
});

export default {
  namespaced: true,
  state: {
    eventos: [],
  },
  getters: {
    getFieldContratadas,
  },
  mutations: {
    updateFieldContratadas,
  },
};
